import angular from 'angular';
import Upload from 'ng-file-upload';

const bannersServices = angular.module('applicationModule.bannersServices', []);


bannersServices.factory('Banners', ['BannersAPI', function (BannersAPI) {
    'use strict';
    return {
        getList: function (appId, params) {
            return BannersAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (id, appId) {
            return BannersAPI.get(id, appId);
        },
        create: function (appId) {
            return BannersAPI.create(appId);
        },
        save: function (banner, editMode) {
            if (editMode) {
                return BannersAPI.edit(banner);
            } else {
                return BannersAPI.store(banner);
            }
        },
        remove: function (id, appId) {
            return BannersAPI.remove(id, appId);
        },
        removeChecked: function (checkedBanners) {
            return BannersAPI.removeChecked(checkedBanners);
        },
        copy: function (bannerId) {
            return BannersAPI.copy(bannerId);
        }
    };
}]);

bannersServices.service('BannersAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';
    const API_URL = AppsoupAPI.API_URL + '/app/images/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.store = function (banner) {
        return $http.post(API_URL + 'store', banner);
    };

    this.create = function (appId) {
        return $http.get(API_URL + 'create', {params: {application_id: appId}});
    };

    this.get = function (id, appId) {
        return $http.get(API_URL + id + '/' + appId);
    };

    this.edit = function (banner) {
        return $http.put(API_URL + 'update/' + banner.id, banner);
    };

    this.remove = function (id, appId) {
        return $http.delete(API_URL + 'delete/' + id + '/' + appId);
    };

    this.removeChecked = function (checkedBanners) {
        return $http.post(API_URL + 'checked/delete', {checkedBanners: checkedBanners});
    };

    this.copy = function (bannerId) {
        return $http.get(API_URL + 'copy/' + bannerId);
    };

}]);

bannersServices.factory('BannerElements', ['BannerElementsAPI', function (BannerElementsAPI) {
    'use strict';
    return {
        getList: function (appId, bannerId, params) {
            return BannerElementsAPI.getList(appId, bannerId, params);
        },
        get: function (id, appId) {
            return BannerElementsAPI.get(id, appId);
        },
        save: function (element, editMode, file, fileGroups) {
            if (file || fileGroups) {
                angular.forEach(element, function (value, key) {
                    if (key === 'app_id' || key === 'banner_id' || key === 'order' || key === 'duration' || key === 'min_age' || key === 'max_age') {
                        element[key] = angular.isString(value) ? parseInt(value) : value;
                    }
                    if (angular.isUndefinedNullOrEmpty(value)) {
                        delete element[key];
                    }
                });
            }
            if (editMode) {
                return BannerElementsAPI.edit(element, file, fileGroups);
            } else {
                return BannerElementsAPI.create(element, file, fileGroups);
            }
        },
        remove: function (id, appId) {
            return BannerElementsAPI.remove(id, appId);
        },
        changeOrder: function (data) {
            return BannerElementsAPI.changeOrder(data);
        },
        changeOrderExtreme: function (data) {
            return BannerElementsAPI.changeOrderExtreme(data);
        }
    };
}]);

bannersServices.service('BannerElementsAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';
    const API_URL = AppsoupAPI.API_URL + '/app/images-element/';

    const checkFiles = function (file, fileGroups) {
        const files = [];
        const names = [];
        if (angular.isDefined(file)) {
            files.push(file);
            names.push('file');
        }
        if (angular.isDefined(fileGroups)) {
            files.push(fileGroups);
            names.push('fileGroups');
        }

        return {files: files, names: names};
    };

    this.getList = function (appId, bannerId, params) {
        return $http.get(API_URL, {
            params: angular.extend(AppsoupAPI.getTableParams(params), {
                application_id: appId,
                parent_id: bannerId
            })
        });
    };

    this.create = function (element, file, fileGroups) {
        const files = checkFiles(file, fileGroups);
        if (angular.isDefined(file) || angular.isDefined(fileGroups)) {
            const newfields = angular.extend(element, {_method: 'POST'});

            return Upload.upload({
                url: API_URL + 'create',
                method: 'POST',
                sendObjectsAsJsonBlob: false,
                fields: newfields,
                file: files.files,
                fileFormDataName: files.names
            });
        } else {
            return $http.post(API_URL + 'create', element);
        }
    };
    this.get = function (id, appId) {
        return $http.get(API_URL + id + '/' + appId);
    };

    this.edit = function (element, file, fileGroups) {
        const files = checkFiles(file, fileGroups);
        if (angular.isDefined(file) || angular.isDefined(fileGroups)) {
            const newfields = angular.extend(element, {_method: 'PUT'});

            return Upload.upload({
                url: API_URL + 'update/' + element.id,
                method: 'POST',
                sendObjectsAsJsonBlob: false,
                fields: newfields,
                file: files.files,
                fileFormDataName: files.names
            });
        } else {
            return $http.put(API_URL + 'update/' + element.id, element);
        }
    };

    this.remove = function (id, appId) {
        return $http.delete(API_URL + 'delete/' + id + '/' + appId);
    };

    this.changeOrder = function (data) {
        const url = API_URL + 'change-order/';

        return $http.post(url, data);
    };

    this.changeOrderExtreme = function (data) {
        const url = API_URL + 'change-order-extreme/';

        return $http.post(url, data);
    };

}]);

export default bannersServices;
